import React from 'react';
import { LegalPage } from './LegalPage';

export const CompliancePage = () => <LegalPage page="compliance" />;
